<template>
     <div style="display: flex; width: 100%; justify-content: space-between; ">
          <div style="padding-bottom: 2rem;">
                <div style="display: flex; justify-content: start; gap: 0.5rem;"  @submit.prevent="fetchList()" title="Search by App name">
                    <div class="search-bar">
                        <i class="fa fa-search input-prefix" />
                        <input type="text"
                        placeholder="Search"
                        v-model="searchText"
                        />
                    </div>
                    <button type="submit" class="btn btn-primary" title="Search" :disabled="searchText.length > 2 ? false:true" @click="searchFilteredApp()">Search</button>
                    <div class="filter-bar" style="gap: 0.5rem;">
                        Filter By:
                        <b-dropdown variant="info" id="dropdown-1" right :text="filterText" class="btn" style="background-color: #17a2b8" >
                            <b-dropdown-item v-for="(filter,i) in filters" :key="filter" @click="changeFilter(i)">{{filter}}</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </div>  
          <div>
          <div style="justify-content: end; gap: 0.5rem; display: flex;">                
            <div class="filter-bar" style="gap: 0.5rem;">
                Page Size:
                <b-dropdown variant="info" id="dropdown-1" :text="pageSize.toString()" class="btn" style="background-color: #17a2b8" >
                    <b-dropdown-item v-for="(page,i) in pageSizes" :key="page" @click="changePage(page)">{{page}}</b-dropdown-item>
                </b-dropdown>
            </div>
            <button type="submit" class="btn btn-primary" title="prev" :disabled="page -1 > -1 ? false:true" @click="prevPage()">Previous page</button>
            <button type="submit" class="btn btn-primary" title="next" :disabled="totalCount > (page +1)* pageSize ? false:true" @click="nextPage()">Next page</button>
          </div>
          
      </div>                   
      </div>
</template>
<script>
import { ReviewStatus, StatusMapping} from "@/constants/Oauth.ts"
require('./style.css')

export default {
    data() {
      return {        
        filters:["Approved", "Pending Review", "Disapproved"],
        pageSizes:[10, 20, 50],
        filterText: "Pending Review",
        searchText: '',
        pageSize: 20,
        status:StatusMapping[this.filterText],
        page: 0,
        total:0,
      }
    },
    props:{
        totalCount: Number
    },
    created() {
      this.filterText =  this.$route.query.type || "Pending Review"        
      this.status = StatusMapping[this.filterText]
    },
    methods: {
       changeFilter(i){
        this.filterText = this.filters[i]
        this.status = StatusMapping[this.filterText]
        this.$emit('update', this.pageSize, this.pageSize*this.page, this.status, this.searchText)
      },
       searchFilteredApp(){
        this.page = 0
        this.$emit('update', this.pageSize, this.pageSize*this.page, this.status, this.searchText)
      },
       changePage(page){
        this.page = 0
        this.pageSize = page
        this.$emit('update', this.pageSize, this.pageSize*this.page, this.status, this.searchText)//limit,skip, status
      },
       nextPage(){
        if(this.totalCount >= (this.page +1)* this.pageSize){
            this.page++
            this.$emit('update', this.pageSize, this.pageSize*this.page, this.status, this.searchText)
        }
      },
       prevPage(){
        if(this.page -1 > -1){
            this.page--
            this.$emit('update', this.pageSize, this.pageSize*this.page, this.status, this.searchText)
        }        
      },
    }
  };
</script>